const matcherMap = {};

export const pathMatchesRoute = function (path, route, matcher, baseUrl = '') {
	if (path == null) { return false; }

	const {host, protocol} = window.location;
	const fqdn = `${protocol}//${host}`;
	const fqdnPath = `${fqdn}${path}`;
	const decodedPath = safeDecode(path);
	const decodedFqdnPath = safeDecode(fqdnPath);

	// if a matcher value is provided, check it first
	if (typeof matcher === 'string' && matcher.length) {
		// if we've never seen this pattern before, cache it
		if (matcherMap[matcher] == null) {
			matcherMap[matcher] = new RegExp(matcher, 'i');
		}
		// check the pattern against the path AND FQDN locations
		return matcherMap[matcher].test(path)
			|| matcherMap[matcher].test(fqdnPath)
			|| matcherMap[matcher].test(decodedPath)
			|| matcherMap[matcher].test(decodedFqdnPath);
	} else if (matcher instanceof Array) {
		// multiple matchers can be provided
		// cache the generated RegExp list for future execution
		if (matcher._re == null) {
			matcher._re = matcher
				.map(rule => {
					if (rule instanceof RegExp) { return rule; }
					if (typeof rule === 'string' && rule.length) { return new RegExp(rule, 'i'); }
					return null;
				})
				.filter(Boolean);
		}
		// check the pattern against the path AND FQDN locations
		return matcher._re.reduce((state, re) => state
			|| re.test(path)
			|| re.test(fqdnPath)
			|| re.test(decodedPath)
			|| re.test(decodedFqdnPath)
		, false);
	} else if (typeof route === 'string') {
		// if the route is an absolute link to the current domain
		// convert to a relative link for path comparison
		if (route.startsWith(fqdn)) { route = route.slice(fqdn.length); }
		route = baseUrl + route;
		return path.startsWith(route);
	}

	// all attempts to match this route have failed
	return false;
};

function safeDecode(value) {
	try { return decodeURIComponent(value); }
	catch (e) { return value; }
}
